export default (event, app) => {
  console.log('[OrderRewardsShouldBeReloaded] Reloading order rewards.', event)

  app.$store.dispatch('order/loadPromotionRewards')
    .then(() => {
      console.log('[OrderRewardsShouldBeReloaded] Rewards were reloaded.')
      app.$store.commit('order/setPromotionsAreChecking', false)
    })
    .catch(err => {
      console.log('[OrderRewardsShouldBeReloaded] Unable to reload rewards.')
      app.$store.commit('order/setPromotionsAreChecking', false)
    })
}
